module.exports = __webpack_public_path__ + "img/thief_bronze.eb4e0873.svg";